import { useEffect } from "react";

export type OutsideClickProps = {
  refs: React.RefObject<HTMLElement | null>[];
  onOutsideClick?: () => void;
};

const useOutsideClick = (props: OutsideClickProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!props.refs || !props.refs.length) return;
      if (
        props.refs.some(
          (ref) => ref?.current && ref.current.contains(event.target as Node),
        )
      )
        return;
      props.onOutsideClick && props.onOutsideClick();
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [props]);
};

export default useOutsideClick;
